import React, { useEffect, useState } from "react";
import { 
  Card, 
  Grid, 
  Button, 
  Box, 
  Typography, 
  CircularProgress,
  Snackbar,
  Alert,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Icon,
  Divider
} from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftSelect from "components/SoftSelect";
import logo from "assets/images/Anser.png";
import cartoonImage from "assets/images/Chat bot-bro.svg";
import successCartoon from "assets/images/Mailbox-bro.svg";
import doneCartoon from "assets/images/Completed steps-rafiki.svg";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import axios from "axios";
import { FAST_API_BASE_URL } from "constants";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { LAMBDA_BASE_URL } from "constants";
import { useNavigate } from "react-router-dom";
import { googleLogout } from "@react-oauth/google";
import { useUser } from "context/UserContext";
import { set } from "date-fns";

const extractDomainName = (input) => {
  if (!input) return '';
  
  let domain = input.trim().toLowerCase();
  domain = domain.replace(/^https?:\/\//, '');
  domain = domain.split('/')[0];
  domain = domain.split(':')[0];
  
  if (domain.startsWith('www.')) {
    domain = domain.substring(4);
  }
  
  return domain;
};

const Registration = () => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isExtraSmallMobile = useMediaQuery('(max-width:360px)');
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  
  const { googleUser, setGoogleUser } = useUser();

  useEffect(()=>{
    if(localStorage.getItem('justRedirected')==="true"){
      localStorage.removeItem('googleUser');
    }
  },[])

  const initialFormData = {
    email: "",
    domainName: "",
    companyName: "",
    firstName: "",
    lastName: "",
    websitePlatform: "",
    isGoogleUser: false
  };

  useEffect(() => {
    const isGoogleUser = localStorage.getItem('googleUser')?true:false;
    if (!isGoogleUser) {
      setGoogleUser(null);
    }
  }, []);

  const [formData, setFormData] = useState(initialFormData);

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [domainError, setDomainError] = useState("");
  const [ansera_search_userIp, ansera_search_setUserIp] = useState("");
  const [timeZone, setTimeZone] = useState("UTC");
  
  const [emailValid, setEmailValid] = useState(true);
  const [emailExists, setEmailExists] = useState(true);
  const [emailChecking, setEmailChecking] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [isnewUser, setisnewuser] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error"
  });

  const websitePlatforms = [
    { value: "wordpress", label: "WordPress" },
    { value: "webflow", label: "Webflow" },
    { value: "wix", label: "Wix" },
    { value: "squarespace", label: "Squarespace" },
    { value: "custom", label: "Others" },
  ];

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    googleLogout();
    setGoogleUser(null);
    localStorage.removeItem("googleUser");
    localStorage.removeItem("googleUser");
    localStorage.clear();
    handleMenuClose();
    navigate("/login");
  };

  const validateEmail = (email) => {
    return emailRegex.test(email);
  };

  const verifyEmailExistence = async (email) => {
    try {
      setEmailChecking(true);
      setEmailError("");

      const response = await axios.get(`https://api.emailvalidation.io/v1/info?apikey=${process.env.REACT_APP_EMAIL_VALIDATION_API_KEY}&email=${email}`);
      
      if (response.data && response.data.state === "deliverable") {
        setEmailExists(true);
        setEmailError("");
      } else {
        setEmailExists(false);
        setEmailError("Email does not exist");
      }
    } catch (error) {
      console.error("Email verification failed:", error);
      setEmailExists(true);
      setEmailError("");
    } finally {
      setEmailChecking(false);
    }
  };

  const showSnackbar = (message, severity = "error") => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };
  const resetForm = () => {
    setFormData(initialFormData);
    setSuccess(false);
    setDomainError("");
    setEmailValid(true);
    setEmailExists(true);
    setEmailError("");
    setisnewuser(false);
  };
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const justRedirected = localStorage.getItem('justRedirected');
        if (justRedirected) {
          localStorage.removeItem('justRedirected');
          resetForm();
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const registrationData = localStorage.getItem('registrationData');
    if (registrationData) {
      setisnewuser(true);
      try {
        const parsedData = JSON.parse(registrationData);
        setFormData(prevData => ({
          ...prevData,
          email: parsedData.email || "",
          firstName: parsedData.firstName || "",
          lastName: parsedData.lastName || "",
          isGoogleUser: parsedData.isGoogleUser || false
        }));
        
        localStorage.removeItem('registrationData');
        
        if (parsedData.email && validateEmail(parsedData.email)) {
          setEmailValid(true);
          setTimeout(() => {
            verifyEmailExistence(parsedData.email);
          }, 500);
        }
      } catch (error) {
        console.error("Error parsing registration data:", error);
        showSnackbar("Error loading registration data", "error");
      }
    }
  }, []);

  useEffect(() => {
    if (formData.email && validateEmail(formData.email)) {
      setEmailValid(true);
      const timer = setTimeout(() => {
        verifyEmailExistence(formData.email);
      }, 1000); 
      
      return () => clearTimeout(timer);
    } else {
      setEmailValid(false);
      setEmailExists(false);
      setEmailError("");
    }
  }, [formData.email]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData({
      ...formData,
      [name]: value,
    });
    
    if (name === "domainName") {
      setDomainError("");
    }
    
    if (name === "email") {
      setEmailValid(false);
      setEmailExists(false);
      setEmailError("");
    }
  };

  const handleSelectChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    const ansera_search_fetchUserIp = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        if (!response.ok) throw new Error("Failed to fetch IP address.");
        const data = await response.json();
        ansera_search_setUserIp(data.ip);
      } catch (error) {
        console.error("Could not fetch user IP address:", error);
        ansera_search_setUserIp("not_available");
        showSnackbar("Could not fetch IP address", "warning");
      }
    };
    ansera_search_fetchUserIp();
  }, []);

  useEffect(() => {
    try {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
      setTimeZone(tz);
    } catch (err) {
      setTimeZone("UTC");
    }
  }, []);

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.email || !formData.domainName || !formData.companyName || !formData.firstName || !formData.lastName || !formData.websitePlatform) {
    showSnackbar("Please fill in all fields", "error");
    return;
  }

  if (!validateEmail(formData.email)) {
    setEmailError("Please enter a valid email address");
    showSnackbar("Please enter a valid email address", "error");
    return;
  }

  if (emailError && emailError !== "Email does not exist") {
    showSnackbar("Please fix email validation errors before submitting", "error");
    return;
  }

  const cleanDomain = extractDomainName(formData.domainName);

  if (cleanDomain === "abc.com") {
    setDomainError("Please contact your admin to add user!");
    showSnackbar("Please contact your admin to add user!", "error");
    return;
  }

  setLoading(true);

  try {
    const payload1 = {
      domain_url: cleanDomain,
      source: formData.websitePlatform.value,
      email: formData.email.trim(),
      first_name: formData.firstName.trim(),
      last_name: formData.lastName.trim(),
    };
    
    const payload = {
      domain: cleanDomain,
      source: formData.websitePlatform.value,
      company_name: formData.companyName.trim(),
      time_zone: timeZone,
      date_formate: "MM-DD-YYYY",
      email: formData.email.trim(),
      user_name: `${formData.firstName.trim()} ${formData.lastName.trim()}`,
      is_google_user: formData.isGoogleUser,
      is_user_logged_in: false
    };
    
    // console.log("payload", payload);
    const response1 = await axios.post(`${LAMBDA_BASE_URL}/save-registration`, payload1, {
      headers: {
        "X-API-KEY": process.env.REACT_APP_API_KEY,
        "Content-Type": "application/json",
      },
    });

    if (formData.websitePlatform.value === "wordpress" || formData.websitePlatform.value === "webflow") {
      showSnackbar("Thank you for registering with Ansera", "success");
      
      localStorage.setItem('justRedirected', 'true');
      setTimeout(() => {
        if (formData.websitePlatform.value === "wordpress") {
          window.location.href = `https://wordpress.org/plugins/ansera-search`;
        } else if (formData.websitePlatform.value === "webflow") {
          window.location.href = "https://webflow.com/apps/detail/ansera-search";
        }
      }, 3000);
    } 
   
    else if (formData.websitePlatform.value === "wix" || formData.websitePlatform.value === "squarespace" || formData.websitePlatform.value === "custom") {
      const response = await axios.post(`${FAST_API_BASE_URL}/api/register?ip_address=${ansera_search_userIp}`, payload, {
        headers: {
          "X-API-KEY": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
      });
      
      if (response.status === 200) {
        if (formData.isGoogleUser || googleUser) {
          localStorage.setItem('domain_name', cleanDomain);
          localStorage.setItem('source', formData.websitePlatform.value);
          localStorage.setItem('role', 'admin');
          localStorage.setItem('domainId', response.data.result.domain_token);
          localStorage.setItem('is_super_admin', 'false');
          localStorage.setItem('name', `${formData.firstName.trim()} ${formData.lastName.trim()}`);
          navigate('/settings');
        } else {
          setSuccess(true);
          showSnackbar("Registration successful! Check your email for next steps.", "success");
        }
      }
    }

    if (response1.status === 200 && formData.websitePlatform.value !== "wordpress" && formData.websitePlatform.value !== "webflow") {
    }
  } catch (err) {
    console.error("Registration failed:", err);
    let errorMessage = "Registration failed. Please try again.";
    
    if (err.response) {
      errorMessage = err.response.data?.messages || 
                    err.response.data?.error || 
                    `Server error: ${err.response.status}`;
    } else if (err.request) {
      errorMessage = "No response from server. Please check your connection.";
    } else {
      errorMessage = err.message || "An unexpected error occurred.";
    }
    
    showSnackbar(errorMessage, "error");
  } finally {
    setLoading(false);
  }
};
  const getResponsiveStyles = () => {
    if (isExtraSmallMobile) {
      return {
        card: {
          padding: "16px",
          margin: "8px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        },
        input: {
          padding: "10px 12px",
          fontSize: "14px",
          borderRadius: "8px",
        },
        label: {
          fontSize: "13px",
          marginBottom: "6px",
        },
        button: {
          padding: "12px 0",
          fontSize: "14px",
        },
        title: {
          fontSize: "0.5rem",
        },
        subtitle: {
          fontSize: "0.8rem",
        },
        gridSpacing: 1.5,
        containerPadding: "8px",
      };
    }

    if (isSmallMobile) {
      return {
        card: {
          padding: "20px",
          margin: "12px",
          borderRadius: "12px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        },
        input: {
          padding: "12px 14px",
          fontSize: "15px",
          borderRadius: "8px",
        },
        label: {
          fontSize: "14px",
          marginBottom: "6px",
        },
        button: {
          padding: "14px 0",
          fontSize: "15px",
        },
        title: {
          fontSize: "1.5rem",
        },
        subtitle: {
          fontSize: "0.875rem",
        },
        gridSpacing: 2,
        containerPadding: "12px",
      };
    }

    if (isMobile) {
      return {
        card: {
          padding: "24px",
          margin: "16px",
          borderRadius: "16px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
        },
        input: {
          padding: "14px 16px",
          fontSize: "16px",
          borderRadius: "10px",
        },
        label: {
          fontSize: "15px",
          marginBottom: "8px",
        },
        button: {
          padding: "16px 0",
          fontSize: "16px",
        },
        title: {
          fontSize: "1.75rem",
        },
        subtitle: {
          fontSize: "1rem",
        },
        gridSpacing: 2.5,
        containerPadding: "16px",
      };
    }

    return {
      card: {
        padding: "32px",
        margin: "0 auto",
        borderRadius: "20px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
        maxWidth: "480px",
      },
      input: {
        padding: "16px 18px",
        fontSize: "16px",
        borderRadius: "12px",
      },
      label: {
        fontSize: "16px",
        marginBottom: "8px",
      },
      button: {
        padding: "16px 0",
        fontSize: "16px",
      },
      title: {
        fontSize: "2rem",
      },
      subtitle: {
        fontSize: "1.125rem",
      },
      gridSpacing: 3,
      containerPadding: "24px",
    };
  };

  const responsiveStyles = getResponsiveStyles();

  return (
    <>
      <SoftBox 
        px={isExtraSmallMobile ? 1 : isSmallMobile ? 2 : 3} 
        py={isExtraSmallMobile ? 0.5 : 1} 
        width="100%" 
        bgColor="white" 
        shadow="sm"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <img 
            src={logo} 
            alt="Ansera Logo" 
            style={{ 
              height: isExtraSmallMobile ? "2.5rem" : 
                      isSmallMobile ? "3rem" : "4rem",
              maxWidth: "100%",
              objectFit: "contain"
            }} 
          />
          {googleUser && (
            <Box>
              <IconButton
                onClick={handleMenuOpen}
                size="small"
              >
                <Avatar
                  src={googleUser?.picture}
                  alt={googleUser?.name}
                  sx={{ 
                    width: 36, 
                    height: 36,
                  }}
                />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                  elevation: 4,
                  sx: {
                    mt: 1.5,
                    borderRadius: 2,
                    overflow: "visible",
                    filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.15))",
                    minWidth: 200,
                    p: 1,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: 1,
                      mr: 1.5,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{
                  horizontal: "right",
                  vertical: "top",
                }}
                anchorOrigin={{
                  horizontal: "right",
                  vertical: "bottom",
                }}
              >
                <MenuItem disableRipple sx={{ py: 1 }}>
                  <Avatar
                    src={googleUser?.picture}
                    sx={{ width: 32, height: 32 }}
                  />
                  <div>
                    <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>
                      {googleUser.name}
                    </div>
                    <div style={{ fontSize: "0.75rem", color: "#555" }}>
                      {googleUser.email}
                    </div>
                  </div>
                </MenuItem>
                <Divider sx={{ my: 0.5 }} />
                <MenuItem
                  onClick={handleLogout}
                  sx={{ 
                    fontWeight: 500, 
                    fontSize: "0.9rem",
                    py: 1
                  }}
                >
                  <Icon sx={{ fontSize: 18, mr: 1 }}>logout</Icon> Sign out
                </MenuItem>
              </Menu>
            </Box>
          )}
        </Box>
      </SoftBox>

      <SoftBox
        minHeight="calc(100vh - 4rem)"
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgColor="#f0f4f7"
        px={responsiveStyles.containerPadding}
        py={isExtraSmallMobile ? 2 : isSmallMobile ? 3 : 4}
      >
        <Grid 
          container 
          spacing={responsiveStyles.gridSpacing} 
          alignItems="center" 
          justifyContent="center" 
          sx={{ 
            maxWidth: "1200px", 
            margin: "0 auto",
            width: "100%"
          }}
        >
          {!isMobile && (
            <Grid item xs={12} md={6} lg={5}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100%"
                px={isTablet ? 2 : 4}
              >
                <Box
                  component="img"
                  src={success ? doneCartoon : cartoonImage}
                  alt="Illustration"
                  sx={{ 
                    width: "100%", 
                    maxWidth: isTablet ? "400px" : "500px", 
                    height: "auto",
                    objectFit: "contain"
                  }}
                />
              </Box>
            </Grid>
          )}

          <Grid item xs={12} sm={10} md={6} lg={5}>
            <Card sx={responsiveStyles.card}>
              {success ? (
                <Box textAlign="center" px={isExtraSmallMobile ? 1 : 2}>
                  <Typography 
                    variant="h4" 
                    fontWeight="bold" 
                    gutterBottom
                    sx={{ 
                      fontSize: isExtraSmallMobile ? "1.25rem" : 
                              isSmallMobile ? "1.5rem" : "2.125rem",
                      lineHeight: 1.2
                    }}
                  >
                    Registration Successful 🎉
                  </Typography>
                  <Typography 
                    variant="body1" 
                    color="text.secondary" 
                    mb={3}
                    sx={{ 
                      fontSize: isExtraSmallMobile ? "0.8rem" : 
                              isSmallMobile ? "0.875rem" : "1rem",
                      lineHeight: 1.4
                    }}
                  >
                    We have sent you an activation link to your mail. Please check.
                  </Typography>
                  <Box
                    component="img"
                    src={successCartoon}
                    alt="Email Sent"
                    sx={{ 
                      width: "100%", 
                      maxWidth: isExtraSmallMobile ? "150px" : 
                               isSmallMobile ? "200px" : "300px", 
                      mx: "auto", 
                      mt: 2,
                      mb: 1
                    }}
                  />
                </Box>
              ) : (
                <Grid container direction="column" spacing={responsiveStyles.gridSpacing}>
                  <Grid item>
                    <Box textAlign="center" px={isExtraSmallMobile ? 1 : 0}>
                      <Typography 
                        variant="h2" 
                        fontWeight="bold" 
                        color="text.primary"
                        sx={responsiveStyles.title}
                      >
                        Register your Domain with Ansera AI
                      </Typography>
                      <Typography 
                        variant="body1" 
                        color="text.secondary" 
                        mt={1}
                        sx={responsiveStyles.subtitle}
                      >
                        Enter your details to register
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item>
                    <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                      <Box mb={responsiveStyles.gridSpacing}>
                        <label htmlFor="email" style={responsiveStyles.label}>
                          Email
                        </label>
                        <Box sx={{ position: "relative", width: "100%" }}>
                          <input
                            id="email"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            required
                            disabled={isnewUser}
                            style={{
                              ...responsiveStyles.input,
                              width: "100%",
                              border: "1px solid #ccc",
                              boxSizing: "border-box",
                              paddingRight: "40px",
                              borderColor: emailError ? 'red' : (emailExists ? 'green' : '#ccc'),
                              transition: "border-color 0.3s ease"
                            }}
                          />
                          <Box 
                            sx={{ 
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              display: "flex",
                              alignItems: "center"
                            }}
                          >
                            {emailChecking && <CircularProgress size={20} />}
                            {emailExists && !emailChecking && (
                              <CheckCircleIcon style={{ color: 'green', fontSize: '20px' }} />
                            )}
                            {emailError && !emailChecking && (
                              <ErrorIcon style={{ color: 'red', fontSize: '20px' }} />
                            )}
                          </Box>
                        </Box>
                        {emailError && (
                          <Typography 
                            variant="body2" 
                            color="error" 
                            sx={{ 
                              mt: 1,
                              fontSize: isExtraSmallMobile ? "11px" : "14px"
                            }}
                          >
                            {emailError}
                          </Typography>
                        )}
                      </Box>

                      <Grid container spacing={responsiveStyles.gridSpacing}>
                        <Grid item xs={12} sm={6}>
                          <Box mb={responsiveStyles.gridSpacing}>
                            <label htmlFor="firstName" style={responsiveStyles.label}>
                              First Name
                            </label>
                            <input
                              id="firstName"
                              name="firstName"
                              type="text"
                              placeholder="Your Firstname"
                              value={formData.firstName}
                              onChange={handleChange}
                              required
                              style={{
                                ...responsiveStyles.input,
                                width: "100%",
                                border: "1px solid #ccc",
                                boxSizing: "border-box"
                              }}
                            />
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <Box mb={responsiveStyles.gridSpacing}>
                            <label htmlFor="lastName" style={responsiveStyles.label}>
                              Last Name
                            </label>
                            <input
                              id="lastName"
                              name="lastName"
                              type="text"
                              placeholder="Your Lastname"
                              value={formData.lastName}
                              onChange={handleChange}
                              required
                              style={{
                                ...responsiveStyles.input,
                                width: "100%",
                                border: "1px solid #ccc",
                                boxSizing: "border-box"
                              }}
                            />
                          </Box>
                        </Grid>
                      </Grid>

                      <Box mb={responsiveStyles.gridSpacing}>
                        <label htmlFor="domainName" style={responsiveStyles.label}>
                          Website Domain Name
                        </label>
                        <input
                          id="domainName"
                          name="domainName"
                          placeholder="example.com"
                          value={formData.domainName}
                          onChange={handleChange}
                          required
                          style={{
                            ...responsiveStyles.input,
                            width: "100%",
                            border: "1px solid #ccc",
                            boxSizing: "border-box"
                          }}
                        />
                        {domainError && (
                          <Typography 
                            variant="body2" 
                            color="error" 
                            sx={{ 
                              mt: 1,
                              fontSize: isExtraSmallMobile ? "11px" : "14px"
                            }}
                          >
                            {domainError}
                          </Typography>
                        )}
                      </Box>

                      <Box mb={responsiveStyles.gridSpacing}>
                        <label htmlFor="websitePlatform" style={responsiveStyles.label}>
                          Website built platform
                        </label>
                        <SoftSelect
                          value={formData.websitePlatform}
                          options={websitePlatforms}
                          onChange={(value) => handleSelectChange("websitePlatform", value)}
                          placeholder="Select Website Platform"
                          label="Website Platform"
                          required
                          sx={{
                            width: "100%",
                            "& .MuiSelect-select": {
                              padding: responsiveStyles.input.padding,
                              fontSize: responsiveStyles.input.fontSize,
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: responsiveStyles.label.fontSize,
                            },
                          }}
                        />
                      </Box>

                      <Box mb={responsiveStyles.gridSpacing}>
                        <label htmlFor="companyName" style={responsiveStyles.label}>
                          Company Name
                        </label>
                        <input
                          id="companyName"
                          name="companyName"
                          placeholder="Sample Inc."
                          value={formData.companyName}
                          onChange={handleChange}
                          required
                          style={{
                            ...responsiveStyles.input,
                            width: "100%",
                            border: "1px solid #ccc",
                            boxSizing: "border-box"
                          }}
                        />
                      </Box>

                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        disabled={loading || emailChecking || (emailError && emailError === "Email does not exist")}
                        sx={{
                          ...responsiveStyles.button,
                          backgroundColor: "#219297",
                          color: "#ffffff",
                          borderRadius: "8px",
                          border: "none",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            backgroundColor: "#1a7a7d",
                            transform: "translateY(-1px)",
                            boxShadow: "0 4px 12px rgba(33, 146, 151, 0.3)"
                          },
                          "&:disabled": {
                            backgroundColor: "#cccccc",
                            cursor: "not-allowed",
                            transform: "none"
                          }
                        }}
                      >
                        {loading ? (
                          <Box display="flex" alignItems="center" justifyContent="center">
                            <CircularProgress size={20} sx={{ color: "white", mr: 1 }} />
                            Registering...
                          </Box>
                        ) : (
                          "Register"
                        )}
                      </Button>
                    </form>
                  </Grid>
                </Grid>
              )}
            </Card>
          </Grid>
        </Grid>
      </SoftBox>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          variant="filled"
          sx={{ 
            width: '100%',
            fontSize: isExtraSmallMobile ? "0.8rem" : "0.875rem",
            alignItems: 'center',
            backgroundColor: snackbar.severity === 'success' ? '#219197' :
                              snackbar.severity === 'warning' ? '#ff9800' :
                              snackbar.severity === 'error' ? '#d21919ff' : '#d32f2f',
            color: '#ffffff'
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Registration;